/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIPagination
 */
export interface APIPagination {
    /**
     * 
     * @type {number}
     * @memberof APIPagination
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof APIPagination
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof APIPagination
     */
    total_count: number;
}

/**
 * Check if a given object implements the APIPagination interface.
 */
export function instanceOfAPIPagination(value: object): value is APIPagination {
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    if (!('total_count' in value) || value['total_count'] === undefined) return false;
    return true;
}

export function APIPaginationFromJSON(json: any): APIPagination {
    return APIPaginationFromJSONTyped(json, false);
}

export function APIPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPagination {
    if (json == null) {
        return json;
    }
    return {
        
        'limit': json['limit'],
        'offset': json['offset'],
        'total_count': json['total_count'],
    };
}

export function APIPaginationToJSON(json: any): APIPagination {
    return APIPaginationToJSONTyped(json, false);
}

export function APIPaginationToJSONTyped(value?: APIPagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limit': value['limit'],
        'offset': value['offset'],
        'total_count': value['total_count'],
    };
}

